
// Imports
import andreas from "../../assets/Orators/andreas_m_papas.webp";
import maria from "../../assets/Orators/maria_richards_brown.webp";
import rassa from "../../assets/Orators/rassa_pegahi.webp";
import anna from "../../assets/Orators/anna_sobanska.webp";
import barbara from "../../assets/Orators/barbara_de_filippis.webp";
import priya from "../../assets/Orators/priya_hays.webp";
import teresa from "../../assets/Orators/teresa_carvajal.webp";
import huiqin from "../../assets/Orators/huiqin_yang.webp";

// Banner imports
import andreas_banner from "../../assets/Orator Banners/andreas_m_papas_banner.webp";
import maria_banner from "../../assets/Orator Banners/maria_richards_brown_banner.webp";
import rassa_banner from "../../assets/Orator Banners/rassa_pegahi_banner.webp";
import anna_banner from "../../assets/Orator Banners/anna_sobanska_banner.webp";
import barbara_banner from "../../assets/Orator Banners/barbara_de_filippis_banner.webp";
import priya_banner from "../../assets/Orator Banners/priya_hays_banner.webp";
import teresa_banner from "../../assets/Orator Banners/teresa_carvajal_banner.webp";
import huiqin_banner from "../../assets/Orator Banners/huiqin_yang_banner.webp";
// Techmatics Images
import Siti from "../../assets/Orator Banners/siti.webp"
import Ab from "../../assets/Orator Banners/ab.webp"
import Jhanvi from "../../assets/Orator Banners/jahavi.webp"
import Abd from "../../assets/Orator Banners/Abd.webp"
import vladimirGChigrinov from "../../assets/Pannel Members/e4.webp"
import jiashengZhu from "../../assets/Pannel Members/e7.webp"
import penouo from "../../assets/Pannel Members/Paneuo.webp"
  export const orators = [
    {
      id: "andreas-m-papas",
      image: Siti,
      name: "Dr. Siti Rahman",
      from: "Malaysia",
      // about: "Adjunct Professor",
      link: "/Quantumtech-orators/siti-rahman"
    },
    {
      id: "maria-richards-brown",
      image: Ab,
      name: "Prof. Abdullah Aydin",
      from: "Turkey",
      // about: "Research Assistant",
      link: "/Quantumtech-orators/abdullah-aydin",
    },
    {
      id: "rassa-pegahi",
      image: Jhanvi,
      name: "Dr. Janani Varun",
      from: "India",
      // about: "PhD in Molecular Biology",
      link: "/Quantumtech-orators/janani-varun",
    },
    {
      id: "anna-w-sobanska",
      image:Abd,
      name: "Prof. Abdeen Omer",
      from: "England",
      // about: "PhD in Organic Chemistry",
      link: "/Quantumtech-orators/abdeen-omer",
    },
    // Second row

  {
    id: "vladimir-g-chigrinov",
    image: vladimirGChigrinov, // replace with actual image import
    name: "Professor Vladimir G. Chigrinov",
    from: "Hong Kong",
    about: "Professor at Hong Kong University of Science and Technology since 1999, renowned for Flat Panel Technology. Author of 6 books, 31 reviews, 333 journal papers, 718 conference presentations, and 121 patents. Editor-in-Chief of the Liquid Crystal section in Crystals journal. Recipient of Excellent Research Award (HKUST) and Slottow Owaki Prize.",
    link: "/Quantumtech-orators/vladimir-g-chigrinov",
  },

  {
    id: "jiasheng-zhu",
    image: jiashengZhu, // replace with actual image import
    name: "Dr. Jiasheng Zhu",
    from: "China",
    about: "Assistant Researcher at Wuhu Hart Robot Technology Research Institute. Research focuses on robotic technologies in shipbuilding, digital twin systems for vessels, and dynamic performance prediction in spraying processes. Led R&D initiatives for COSCO Group and Wuhu Digang Shipyard. Holds 13 patents, 11 peer-reviewed papers, contributed to 4 provincial research programs, formulated 2 Chinese national standards for magnetic wall-climbing robots, and received 5 international robotics awards.",
    link: "/Quantumtech-orators/jiasheng-zhu",
  },
  {
    id: "paulo-c-de-morais",
    image: penouo, // replace with actual image import
    name: "Prof. Paulo C. De Morais",
    from: "Brazil",
    about: "Emeritus Professor of Physics at the University of Brasília. Held academic positions in Brazil and China (Huazhong University of Science and Technology, Anhui University). Senior IEEE member and CNPq-1A research fellow. Research in nanomaterials, including magnetic fluids and quantum dots. Author of 500+ publications, 15+ patents, and 13,000+ citations. Recipient of China’s 1000 Foreign Expert award and featured in top scientist rankings (Stanford, AD Scientific Index).",
    link: "/Quantumtech-orators/paulo-c-de-morais",
  },

  ];

// Detailed orator data

export const siti_rahman_data = {
  id: "siti-rahman",
  image: Siti,
  from: "Malaysia",
  name: "Dr. Siti Rahman",
  banner:"https://tse2.mm.bing.net/th/id/OIP.1371Gx86Ol63EoZIf-R8jgHaEK?pid=Api&P=0&h=180",
  about:
    "Dr. Siti Soraya binti Abdul Rahman received the Ph.D. degree in Cognitive Science from the University of Sussex, U.K., in 2012. She is currently a Senior Lecturer with the Department of Artificial Intelligence, Faculty of Computer Science and Information Technology at the Universiti Malaya. Her current research interests and expertise are in the areas of advanced language models and prompt engineering; data-driven knowledge representation and semantic understanding leveraging neural network models; deep learning-driven advancements in spatiotemporal data modeling and visual perception tasks; Artificial Intelligence of Things (AIoT); and research in aspect-based sentiment analysis with a focus on contextual interpretation.",
};

export const abdullah_aydin_orator_data = {
  id: "abdullah-aydin",
  image: Ab,
  from: "Turkey",
  name: "Prof. Abdullah Aydin",
  banner:"https://tse2.mm.bing.net/th/id/OIP.S8zM5-dIp93O1OgELUL4HwHaEK?pid=Api&P=0&h=180",
  about:
   "Abdullah Aydın is a Professor of Science/Chemistry Education at Kırşehir Ahi Evran University, Turkey. He holds a Master’s in Analytical Chemistry from Uludağ University (1995) and a Ph.D. from Gazi University (2004). Abdullah is on the editorial teams of 74 international journals and has received 11 excellence awards in reviewing. He has numerous committee memberships and has earned both national and international awards for his contributions. His research focuses on Analytical Chemistry, trace element analysis, and materials science. For more details, check out VDGOOD Technology Factory.",
};

export const janani_varun_data = {
  id: "janani-varun",
  image: Jhanvi,
  from: "India",
  name: "Dr. Janani Varun",
  banner: "https://images6.alphacoders.com/911/911295.webp",
  about:
"Dr. Janani Varun is a distinguished expert in Generative AI, Large Language Models (LLM) and Machine Learning, with over 14+ years of experience in the IT industry. She holds a PhD in Computer Science and Engineering and has patent contributions in AI workflows and hallucination detection, as well as pioneering enhancements to the silhouette score.As a Senior Consultant at Infosys Center for Emerging Technology Solutions (ICETS), Dr. Janani Varun has led transformative AI projects across industries, including generative AI solutions such as chatbots, text summarization tools, and recommendation engines. She has spearheaded cutting-edge innovations in AI governance, model operationalization, and reducing model hallucinations.An accomplished thought leader, Dr. Janani Varun has authored technical blogs, white papers, and research articles in Springer and SCI journals. She is a sought-after speaker, having delivered guest lectures and seminars on Generative AI at industry conferences and academic institutions. Recognized for her mentorship and innovation, she has been instrumental in training the next generation of AI professionals. Dr. Janani Varun’s work emphasizes responsible AI practices and leveraging AI to deliver measurable business value.",
};

export const abdeen_omer_data = {
  id: "abdeen-omer",
  image: Abd,
  from: "England",
  name: "Prof. Abdeen Omer",
  banner:"https://tse3.mm.bing.net/th/id/OIP.9zAihr2mbg4E6Gg4jtWQ0wHaEK?pid=Api&P=0&h=180",
  about:
   "Dr. Abdeen Mustafa Omer (BSc, MSc, PhD) is an Associate Researcher at Energy Research Institute (ERI). He obtained both his PhD degree in the Built Environment and Master of Philosophy degree in Renewable Energy Technologies from the University of Nottingham. He is qualified Mechanical Engineer with a proven track record within the water industry and renewable energy technologies. He has been graduated from University of El Menoufia, Egypt, BSc in Mechanical Engineering. His previous experience involved being a member of the research team at the National Council for Research/Energy Research Institute in Sudan and working director of research and development for National Water Equipment Manufacturing Co. Ltd., Sudan. He has been listed in the book WHO’S WHO in the World 2005, 2006, 2007 and 2010. He has published over 300 papers in peer-reviewed journals, 200 review articles, 30 books and 150 chapters in books.",
};

export const vladimir_g_chigrinov_orator_data = {
  id: "vladimir-g-chigrinov",
  image: vladimirGChigrinov,
  from: "Hong Kong",
  name: "Professor Vladimir G. Chigrinov",
  banner:"https://tse4.mm.bing.net/th/id/OIP.divbzSos7iE1Sy1wxvFj9AHaEK?pid=Api&P=0&h=180",
  about:
    "Professor Vladimir G. Chigrinov has been a Professor at the Hong Kong University of Science and Technology since 1999, renowned for his work in Flat Panel Technology. With 6 books, 31 reviews, 333 journal papers, 718 conference presentations, and 121 patents, he has made significant contributions to liquid crystals research since 1974. He has received numerous accolades, including the Excellent Research Award from HKUST and the Slottow Owaki Prize. Currently, he is the Editor-in-Chief of the Liquid Crystal section in Crystals journal. For more details, visit his Webpage",
};

export const jiasheng_zhu_orator_data = {
  id: "jiasheng-zhu",
  image: jiashengZhu,
  from: "China",
  name: "Dr. Jiasheng Zhu",
  banner: "https://img.freepik.com/premium-photo/chinese-flag_956664-2789.webp",
  about:
    "Jiasheng Zhu graduated from Dalian Ocean University with a Ph.D. in Mechanical Engineering. He currentlyservesasanAssistant Researcher at Wuhu Hart Robot Technology Research Institute. His main research interests encompass robotictechnologies in shipbuilding industry, digital twin systems for vessels, and dynamic performance predictioninsprayingprocesses. As a project manager, he has led key R&D initiatives including an industrial robot development project for COSCOGroup and a specialized robotic system implementation project at Wuhu Digang Shipyard. He has contributedtofourprovincial-level research programs funded by Liaoning Department of Education and Department of Science &Technology.With 13 patent applications in related fields, he has published 11 peer-reviewed papers as first or correspondingauthorindomestic and international journals. Dr. Zhu played a pivotal role in formulating two Chinese national standards for magneticwall-climbing robots and has received five prestigious international robotics awards.",
};

export const paulo_c_de_morais_data = {
  id: "paulo-c-de-morais",
  image: penouo,
  from: "Brazil",
  name: "Prof. Paulo C. De Morais",
  banner: "https://cdn.pixabay.com/photo/2017/12/06/11/03/brazil-3001462_1280.webp",
  about:
   "Paulo C. de Morais, PhD, is Emeritus Professor of Physics at the University of Brasília and has held prominent academic positions in Brazil and China, including at Huazhong University of Science and Technology and Anhui University. A senior IEEE member and CNPq-1A research fellow since 2010, he has over 40 years of experience in nanomaterials research, with more than 500 peer-reviewed publications, 13,000+ citations, and 15+ patents. His work focuses on nanosized materials, including magnetic fluids and quantum dots. Recognized globally, he has received awards such as China’s 1000 Foreign Expert and appears in top scientist rankings including Stanford (2020) and AD Scientific Index (2023, 2025).",
};

// Map for lookup
export const orators_details_map = {
  // "andreas-m-papas": andreas_m_papas_data,
  // "maria-richards-brown": maria_richards_brown_data,
  // "rassa-pegahi": rassa_pegahi_data,
  // "anna-w-sobanska": anna_w_sobanska_data,
  // "barbara-de-filippis": barbara_de_filippis_data,
  // "priya-hays": priya_hays_data,
  // "teresa-carvajal": teresa_carvajal_data,
  // "huiqin-yang": huiqin_yang_data,

  // ✅ Newly added orators
  "siti-rahman": siti_rahman_data,
  "abdullah-aydin": abdullah_aydin_orator_data,
  "janani-varun": janani_varun_data,
  "abdeen-omer": abdeen_omer_data,
  "vladimir-g-chigrinov": vladimir_g_chigrinov_orator_data,
  "jiasheng-zhu": jiasheng_zhu_orator_data,
  "paulo-c-de-morais": paulo_c_de_morais_data,
};

